export default __webpack_public_path__ + "static/media/Honored Helm of the Clans.b3428cb6.jpg";